const NOTCH_HALF_WIDTH_PX = 14; // half of 28px total arrow base

function initTapToOpenDropdowns() {
    document.querySelectorAll('.nds-nav__item--has-dropdown > .nds-nav__link').forEach(link => {
        link.addEventListener('click', (event) => {
            if (window.matchMedia('(hover: none)').matches) {
                event.preventDefault();
            }
        });
    });
}

/**
 * Measures the NDS header height and sets CSS custom properties used by the
 * mobile nav sub-panels and the desktop notch:
 *
 *   --nds-header-height   the full height of the sticky header
 *   --nds-subnav-top      header height — kept for any legacy consumers
 *
 * Where to Buy, Find a Pro, and Contact Us are all pinned as flex siblings
 * outside <ul class="nav">, so no bottom/top offset measurement is needed.
 */
function setNavHeightVars() {
    const header = document.querySelector('.nds-header');
    if (!header) return;

    const headerHeight = header.getBoundingClientRect().height;

    document.documentElement.style.setProperty('--nds-header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--nds-subnav-top',    `${headerHeight}px`);
}

function initNdsNavNotch() {
	document.querySelectorAll('.nds-nav__item--has-dropdown').forEach(item => {
		const link = item.querySelector('.nds-nav__link');
		const dropdown = item.querySelector('.nds-nav__dropdown');
		if (!link || !dropdown) return;

		const linkWidth = link.offsetWidth;

		// Skip when the nav is not visible (e.g. mobile viewport with display:none)
		if (linkWidth === 0) return;

		let notchLeft;

		if (item.classList.contains('nds-nav__item--mega')) {
			// Mega menu is full-width; its left edge does not align with the nav item.
			// Use absolute viewport positions to compute the notch offset correctly.
			const linkRect     = link.getBoundingClientRect();
			const dropdownRect = dropdown.getBoundingClientRect();
			notchLeft = linkRect.left + (linkRect.width / 2) - dropdownRect.left - NOTCH_HALF_WIDTH_PX;
		} else {
			// Regular dropdown is positioned directly below its nav item,
			// so the notch offset is simply the center of the link.
			notchLeft = (linkWidth / 2) - NOTCH_HALF_WIDTH_PX;
		}

		dropdown.style.setProperty('--notch-left', `${notchLeft}px`);
	});
}

function init() {
    setNavHeightVars();
    initNdsNavNotch();
    initTapToOpenDropdowns();

    // Recalculate once web fonts are loaded — link widths change after font swap.
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
            setNavHeightVars();
            initNdsNavNotch();
        });
    }

    // Recalculate when the mobile nav opens — WTB element has zero rendered height
    // while the nav is closed. Wrap in rAF so the browser completes layout before
    // we measure, avoiding getBoundingClientRect() returning 0.
    const observer = new MutationObserver(() => {
        if (document.documentElement.classList.contains('nav-open')) {
            requestAnimationFrame(() => setNavHeightVars());
        }
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // rAF-throttled resize handler — fires at most once per animation frame.
    let resizeRaf = null;
    window.addEventListener('resize', () => {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(() => {
            setNavHeightVars();
            initNdsNavNotch();
        });
    });
}

export { init }
